import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'formatDueDate',
    standalone: false,
    pure: true
})
export class FormatDueDatePipe implements PipeTransform {
  transform(dueDate: string): string {
    if (!dueDate) {return '';}
    const date = new Date(dueDate);
    return date.toLocaleDateString('en-US', { month: 'short', day: 'numeric' });
  }
}
